import { render, staticRenderFns } from "./transferStage.vue?vue&type=template&id=2fdc6b3f&scoped=true&"
import script from "./transferStage.vue?vue&type=script&lang=js&"
export * from "./transferStage.vue?vue&type=script&lang=js&"
import style0 from "./transferStage.vue?vue&type=style&index=0&id=2fdc6b3f&scoped=true&lang=css&"
import style1 from "./transferStage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc6b3f",
  null
  
)

export default component.exports